import React from "react";
import _ from "lodash";
import set from "@rill/set";
import cx from "classnames";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import EditPreviousCompetitionModal from "./edit-previous-competition";
import EditUpcomingCompetitionModal from "./edit-upcoming-competition";

function View(props, { locals }) {
  const { listCompetitions, query, momentTZ } = locals;
  const now = momentTZ().endOf("day");
  const dateFilter = query.list === "previous" ? "isBefore" : "isAfter";
  let activeCompetitions = _.sortBy(
    _.filter(listCompetitions, ({ date }) => momentTZ(date)[dateFilter](now)),
    "date"
  );
  if (query.list === "previous")
    activeCompetitions = _.reverse(activeCompetitions);

  return (
    <div className="Competitions">
      <div className="Sub-Header">
        {query.list === "previous" ? (
          <a
            className="button"
            href={`/actions/refresh?modal[type]=edit-previous-competition&add=true`}
          >
            Add Previous
          </a>
        ) : (
          <a
            className="button"
            href={`/actions/refresh?modal[type]=edit-upcoming-competition&add=true`}
          >
            Add Upcoming
          </a>
        )}
        <a
          className="text-button icon sm metrics"
          href="/dashboard/metrics/competition-history"
        >
          <img src="/img/svg/icon_competition.svg" alt="icon" />
          Competition History <br /> Metrics
        </a>
      </div>

      <div className="Main">
        <div className="Competition-List">
          <div className="head">
            <ToggleLinksInput
              className="alt"
              name="list"
              options={[
                { text: "Previous", value: "previous" },
                { text: "Upcoming", value: "upcoming" },
              ]}
            />
          </div>

          <div className="competitions">
            {_.map(activeCompetitions, (competition) => {
              const date = momentTZ(competition.date);
              const pending =
                query.list === "previous" && !competition.finished;
              return (
                <div key={competition._id} className="competition">
                  <div className="date">
                    {`${date.format("MMM D")}, ${date.format("YYYY")}`}
                  </div>
                  <div className="title">{competition.name}</div>
                  <div className="actions">
                    <a
                      href={`/actions/refresh?modal[type]=edit-${query.list}-competition&competition=${competition._id}&add=false`}
                      className={cx(`button ${pending ? "add-result" : ""}`, {
                        outline: !pending,
                      })}
                    >
                      {pending ? "Add Result" : "Edit"}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

const Competitions = (app) => {
  app
    .use(set("heading", ["Athlete", "Competition Tracker"]))
    .get("/", async ({ res, req, load, locals }) => {
      const modal = _.get(req.query, "modal", {});
      const add = _.get(req.query, "add", false);

      const competition = _.get(req.query, "competition", null);

      _.defaults(req.query, { list: "previous" });
      await load("listCompetitions");
      if (competition && !add) {
        await load("editCompetition", { competition });
      } else {
        locals.editCompetition = null;
      }

      locals.modal = {
        "edit-previous-competition": (
          <EditPreviousCompetitionModal locals={locals} />
        ),
        "edit-upcoming-competition": (
          <EditUpcomingCompetitionModal locals={locals} />
        ),
      }[modal.type];
      res.body = <View />;
    });
};

export default Competitions;
